import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CoursesPage = lazy(() => import('../pages/courses/page'));
const CourseDetailPage = lazy(() => import('../pages/course-detail/page'));
const QuizzesPage = lazy(() => import('../pages/quizzes/page'));
const SchedulePage = lazy(() => import('../pages/schedule/page'));
const LibraryPage = lazy(() => import('../pages/library/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/courses',
    element: <CoursesPage />
  },
  {
    path: '/courses/:id',
    element: <CourseDetailPage />
  },
  {
    path: '/quizzes',
    element: <QuizzesPage />
  },
  {
    path: '/quizzes/:id',
    element: <QuizzesPage />
  },
  {
    path: '/schedule',
    element: <SchedulePage />
  },
  {
    path: '/library',
    element: <LibraryPage />
  },
  {
    path: '/guest',
    element: <Navigate to="/" replace />
  },
  {
    path: '/register',
    element: <Navigate to="/courses" replace />
  },
  {
    path: '/login',
    element: <Navigate to="/courses" replace />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;